module.exports = __webpack_public_path__ + "img/8.2e41770f.webp";